import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@acorn-portal/shared/src/store';
import { WelcomePackSendStatus } from '../services/subscriptionAPI';

export interface TakeUpDetailsState {
	policyNumber: string;
	sendWelcomePackStatus: WelcomePackSendStatus;
	startTime: Date;
}

const initialState: TakeUpDetailsState = {
	policyNumber: '',
	sendWelcomePackStatus: WelcomePackSendStatus.NOT_SENT,
	startTime: new Date(),
};

const takeUpDetailsSlice = createSlice({
	name: 'takeUpDetails',
	initialState,
	reducers: {
		setTakeUpDetails(state, action: PayloadAction<TakeUpDetailsState>) {
			return { ...state, ...action.payload };
		},
		clearTakeUpDetails() {
			return initialState;
		},
	},
});

export const { setTakeUpDetails, clearTakeUpDetails } = takeUpDetailsSlice.actions;
export default takeUpDetailsSlice.reducer;

export const selectTakeUpDetails = (state: RootState) => state.takeUpDetails;
